

























import SearchEntity from "./SearchEntity.vue";
import Vue from "vue";
import { SharedState } from "@/common/state";
import { UseModal } from "@/components/root/modal";
import InvestigationModalVue from "./InvestigationModal.vue";
import { PopulationTypeHelper, POPULATION_TYPE } from "@/common/models";

export default Vue.extend({
  props: ["is_expended"],
  components: { SearchEntity },
  setup() {
    const open_investigation_modal = () => {
      // alert("open");
    };

    const investigate = (selectedItem: any) => {
      if (SharedState.restrictions.is_restricted_app("entity_investigation")) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Entity Investigation"
        );
        return;
      }
      if (SharedState.restrictions.is_restricted_entity(selectedItem.type)) {
        SharedState.restrictions.show_restrictions_modal(
          "entity",
          PopulationTypeHelper.asString(selectedItem.type, true)
        );
        return;
      }

      if (selectedItem.type === POPULATION_TYPE.LABEL) {
        const label = SharedState.allInfoTypes.value[selectedItem.id];
        if (SharedState.restrictions.is_restricted_info(label.code)) {
          SharedState.restrictions.show_restrictions_modal(
            "info",
            label.labelName
          );
          return;
        }
      }

      console.log("selectedItem: ", selectedItem);
      if (selectedItem) {
        SharedState.investigation.investigate({
          ...selectedItem,
          cluster_id: selectedItem?.clusterUID,
        });
      }
    };

    const expend = () => {
      UseModal().show(InvestigationModalVue);
    };
    return {
      open_investigation_modal,
      investigate,
      expend,
    };
  },
});
